module.exports = __webpack_public_path__ + "static/media/icon-table-pause.ded52bc7.svg";